var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"105827d533c70b8b2f42c3131496a748e5ae764f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["wikifactory@wikifactory"]={id:"105827d533c70b8b2f42c3131496a748e5ae764f"};
      